<div class="aldcs-device-autocomplete-styles mat-typography">
  <ng-container>
    <div class="aldcs-device-autocomplete-container col-lg-6 col-md-12 col-sm-12 col-xs-12">
      <div class="aldcs-device-autocomplete-text-container">
        <div ifSettingTrue="DeviceSearch_IsEnabled" class="aldcs-header" style="font-size:22.5px; font-weight: 600; line-height:normal;"><adp-label labelKey="DeviceSearch_Header"></adp-label></div>
        <div ifSettingTrue="DeviceSearch_IsEnabled" class="aldcs-header"><adp-label labelKey="DeviceSearch_Subheader"></adp-label></div>
        <div ifSettingFalse="DeviceSearch_IsEnabled" class="aldcs-header" style="font-size:22.5px; font-weight: 600; line-height:normal;"><adp-label labelKey="DeviceSearch_AddOnly_Header"></adp-label></div>
        <div ifSettingFalse="DeviceSearch_IsEnabled" class="aldcs-header"><adp-label labelKey="DeviceSearch_AddOnly_Subheader"></adp-label></div>
      </div>
      <div class="aldcs-device-autocomplete-search-field">
        <form>
          <mat-form-field class="aldcs-device-autocomplete-search-width" >
            <mat-icon ifSettingTrue="DeviceSearch_IsEnabled" *ngIf="!loading" matSuffix>search</mat-icon>
            <mat-spinner [diameter]="20" *ngIf="loading" style="right:10px;position:absolute;top:10px; margin-top: 15px;z-index: 100;"></mat-spinner>
            <input ifSettingTrue="DeviceSearch_IsEnabled" type="text" matInput placeholder="" sf-aria-label="Global_Search_Aria_Label" [formControl]="searchControl"
              [matAutocomplete]="auto">
            <mat-autocomplete ifSettingTrue="DeviceSearch_IsEnabled" autoActiveFirstOption #auto="matAutocomplete" (optionSelected)="selected($event)"
              [displayWith]="displayFn">
              <mat-option *ngFor="let option of uniqueSearchResults" [value]="option">
                <div *ngIf="option.Description === noSearchResultsDisplayMessage" class="aldcs-device-autocomplete-no-results">
                  <div class="aldcs-device-autocomplete-no-results-message">{{noSearchResultsDisplayMessage}}</div>
                  <div role="link" class="aldcs-device-autocomplete-no-results-action"><adp-label labelKey="DeviceSearch_EnterDetails_Label"></adp-label></div>
                </div>
                <div *ngIf="option.Description !== noSearchResultsDisplayMessage">
                  {{option.Description}}
                </div>
              </mat-option>
            </mat-autocomplete>
            <button ifSettingFalse="DeviceSearch_IsEnabled" (click)="addToProducts()" mat-flat-button color="accent" style="max-width:50%;">
            <adp-label labelKey="DeviceSearch_Add_MyDevices_Button_Text"></adp-label>
          </button>
          </mat-form-field>
        </form>
      </div>
    </div>
    <div class="aldcs-background-image col-lg-6" [ngStyle]="{'background-image': 'url(' + backgroundImageURL + ')'}"></div>
  </ng-container>
</div>
